// extracted by mini-css-extract-plugin
export default {"shareButton":"ShareButton_shareButton__-X5ew"};